import { render } from "./BarCode.vue?vue&type=template&id=256f71fa"
import script from "./BarCode.vue?vue&type=script&lang=js"
export * from "./BarCode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__